import { render, staticRenderFns } from "./OperaProjectDetailWindow.vue?vue&type=template&id=84167720&scoped=true&"
import script from "./OperaProjectDetailWindow.vue?vue&type=script&lang=js&"
export * from "./OperaProjectDetailWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaProjectDetailWindow.vue?vue&type=style&index=0&id=84167720&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84167720",
  null
  
)

export default component.exports